module.exports = __webpack_public_path__ + "media/icons/idea-icon-9f984a54.png";